import { z } from "zod";
import { tidSchemaFactory } from "../../utils/validation.ts";
import { baseFileSchema } from "../base-file/base-file.validation.ts";
import { FILE_TYPE_ID, type GrafitFile } from "./file.ts";

export const grafitFileSchema = baseFileSchema.extend({
  id: tidSchemaFactory(FILE_TYPE_ID),
  uploadedById: z.string(),
}) satisfies z.ZodType<GrafitFile>;

export const createGrafitFileSchema = grafitFileSchema.omit({ uploadedById: true });
